(function($) {

    function showVideo($this) {
        var youtubeSlug = $this.data('youtube');
        $this.parent('.event-content-video-reel').find('.video-embed-container iframe').attr('src', 'https://www.youtube-nocookie.com/embed/' + youtubeSlug + '?rel=0&autoplay=1&showinfo=0');
        setTimeout(function(){$this.parent('.event-content-video-reel').find('.video-embed-container').fadeIn(400);}, 100);
    }

    function hideVideo($this) {
        $this.parent('.event-content-video-reel').find('.video-embed-container').fadeOut(400, function() {
            $this.parent('.event-content-video-reel').find('.video-embed-container iframe').attr('src', '');
        });
    }

    function videoSetup() {
        $('.video-link').on('click', function (e) {
            console.log('test');
            showVideo($(this));
            e.preventDefault();
            e.stopPropagation();
        });
        $(document).on('click', function() {
            $('.video-link').each(function(){
                hideVideo($(this));
            });
        });
    }

    function videoAspectRatio() {
        console.log('yes');
        var videoWidth = $('.event-content-video-reel').width();
        var videoHeight = Math.floor(videoWidth * (9/16));
        $('.event-content-video-reel').height(videoHeight);
        $('.event-content-video-reel iframe').height(videoHeight);
    }

    function billboardAspectRatio() {
        var billboardWidth = $('.billboard-video-container').width();
        var billboardHeight = Math.floor(billboardWidth * (9/16));
        $('.billboard').height(billboardHeight);
        $('.event-billboard-container').height(billboardHeight).addClass('visible');
    }

function getViewportDimensions() {
    var dimensions = new Array();
    dimensions['w'] = $(window).width();
    dimensions['h'] = $(window).height();
    return dimensions;
}

    function videoLoader() {
        var dimensions = getViewportDimensions();
        if(dimensions['w'] > 768 && $('.billboard-video video').length === 0) {
            $('.billboard-gif').hide();
            var video = $('<video class="scale_video" preload="auto" autoplay="" loop="true" muted><source src="/wp-content/themes/cablelabs-v23/btp/videos/summer-conference-2018.m4v" type="video/mp4"><source src="/wp-content/themes/cablelabs-v23/btp/videos/summer-conference-2018.webm" type="video/webm"></source></video>');
            $('.billboard-video').append(video);
        } else if(dimensions['w'] <= 768) {
            if($('.billboard-video video').length > 0) {
                $('.billboard-video video')[0].pause();
            }
            $('.billboard-video').empty();
            $('.billboard-gif').show();
        }
    }



    /****PAGE LOAD ACTIONS****/
    videoSetup();
    videoLoader();
    videoAspectRatio();
    billboardAspectRatio();


    /****RESIZE ACTIONS****/
    $(window).resize(function() {
        videoLoader();
        videoAspectRatio();
        billboardAspectRatio();
    });


})(jQuery);
